import { render, staticRenderFns } from "./ConsumerDashboardPrepaid.vue?vue&type=template&id=0ab1068f&scoped=true&"
import script from "./ConsumerDashboardPrepaid.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboardPrepaid.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboardPrepaid.vue?vue&type=style&index=0&id=0ab1068f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab1068f",
  null
  
)

export default component.exports